import { Component, OnInit } from '@angular/core';
import {ModalComponent, ModalExtended} from 'ngx-dynamic-modal';

@Component({
  selector: 'app-stats-chart-modal',
  templateUrl: './stats-chart-modal.component.html',
  styleUrls: ['./stats-chart-modal.component.scss']
})
export class StatsChartModalComponent extends ModalExtended implements OnInit {

    data: any;
    labels: Array<string>;
    series: Array<string>;
    chartType: string = 'pie';

    constructor(){
        super();

    }

    ngOnInit() {
        this.labels = this.data.labels;
        this.series = this.data.series;
    }

    onExit(){
        this.applyCallback('any data');
        this.close();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/components/modal/stats-chart-modal/stats-chart-modal.component.ts